import { useEffect, useState } from 'react'
import { observer, inject } from 'mobx-react'
import styled from '@emotion/styled'

import { Drawer } from '../../../components'
import ProfileCard from '../ProfileCard'
import ProfileField from '../ProfileField'
import { FieldGroup } from '../ProfileStyle'
import EditLoginInfo from './EditLoginInfo'

function LoginCard({
  store: {
    getLoginEmail,
    getRetailLoginEmail,
    config,
    hasPlanAccess,
    loginStore: { username },
    config: { isRetail },
  },
}) {
  const fetchUserName = async () => {
    try {
      if (config.isRetail) {
        // Skip email request: it returns 403 without plan access, and the retail card doesn't use the email.
        if (hasPlanAccess) {
          await getRetailLoginEmail()
        }
      } else {
        await getLoginEmail()
      }
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    fetchUserName()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [drawer, setDrawer] = useState('')
  return (
    <ProfileCard title='Login info' handleEdit={() => setDrawer('EditLoginInfo')}>
      <FieldGroup>
        {!isRetail && (
          <ProfileField label='Email' value={<ValueInner>{username || '********'}</ValueInner>} />
        )}
        <ProfileField label='Password' value={<ValueInner>********</ValueInner>} />
      </FieldGroup>
      <Drawer
        active={drawer === 'EditLoginInfo'}
        title='Login info'
        subtitle='Edit profile'
        width='50%'>
        <EditLoginInfo handleCancel={() => setDrawer('')} />
      </Drawer>
    </ProfileCard>
  )
}

export default inject('store')(observer(LoginCard))

const ValueInner = styled.div`
  display: flex;
  justify-content: space-between;
`
